/*
  Copyright 2018-2020 National Geographic Society

  Use of this software does not constitute endorsement by National Geographic
  Society (NGS). The NGS name and NGS logo may not be used for any purpose without
  written permission from NGS.

  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed
  under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/
import MomentUtils from '@date-io/moment';
import moment from 'moment-timezone';
import { CssBaseline, ThemeProvider as MuiThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import theme from './theme';
import React from 'react';

interface IProps {
  children?: React.ReactNode;
  themeConfig?: any;
}

moment.tz.setDefault('Etc/UTC');

export const ThemeProvider = (props: IProps) => {
  const { children, themeConfig } = props;

  return (
    <>
      <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
        <MuiThemeProvider theme={theme(themeConfig)}>
          <CssBaseline>{children}</CssBaseline>
        </MuiThemeProvider>
      </MuiPickersUtilsProvider>
    </>
  );
};
